const DEFAULT_THEME = {
  color_primary: '#1890ff',
  color_text: '#1a1a1a',
  color_text_secondary: '#555555',
  color_bg_base: '#f5f7fb',
  color_bg_container: '#ffffff',
  font_family: 'Inter, system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif',
  font_size: 14,
};

const normalizeTheme = (value) => {
  if (!value || typeof value !== 'object') {
    return { ...DEFAULT_THEME };
  }
  const next = { ...DEFAULT_THEME };
  Object.keys(DEFAULT_THEME).forEach((key) => {
    if (value[key] !== undefined && value[key] !== null && String(value[key]).trim() !== '') {
      next[key] = key === 'font_size' ? Number(value[key]) : String(value[key]);
    }
  });
  if (!Number.isFinite(next.font_size) || next.font_size <= 0) {
    next.font_size = DEFAULT_THEME.font_size;
  }
  return next;
};

const toAntdTheme = (themeValue) => {
  const theme = normalizeTheme(themeValue);
  return {
    token: {
      colorPrimary: theme.color_primary,
      colorText: theme.color_text,
      colorTextSecondary: theme.color_text_secondary,
      colorBgBase: theme.color_bg_base,
      colorBgContainer: theme.color_bg_container,
      fontFamily: theme.font_family,
      fontSize: theme.font_size,
    },
  };
};

export { DEFAULT_THEME, normalizeTheme, toAntdTheme };
